"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
var react_apollo_1 = require("react-apollo");
var ShowMembers = require("../../core/gql/queries/show-members");
var merge_members_modal_1 = require("./merge-members-modal");
var react_router_dom_1 = require("react-router-dom");
var lodash_1 = require("lodash");
var defaultPageSize = 50;
var displayLastNameFirst = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    var name = "";
    if (firstName && firstName !== null) {
        name = "" + firstName;
    }
    if (lastName && lastName !== null) {
        name = lastName + ", " + name;
    }
    return name;
};
var MemberList = function (_a) {
    var orgId = _a.orgId;
    var _b = react_apollo_1.useQuery(ShowMembers.QUERY, {
        variables: { organizationId: orgId, pageNumber: 1, pageSize: defaultPageSize, searchTerm: "" },
    }), data = _b.data, refetch = _b.refetch;
    var _c = React.useState([]), mergeMembers = _c[0], setMergeMembers = _c[1];
    var _d = React.useState(false), forceReload = _d[0], setForceReload = _d[1];
    React.useEffect(function () {
        if (forceReload) {
            setForceReload(false);
        }
    }, [forceReload]);
    var columns = [
        { name: "name", label: "Member Name", isSortable: false, mods: "u-size1of2" },
        { name: "gender", label: "Gender", isSortable: false, mods: "u-size1of2" },
        { name: "birthdate", label: "Birthdate", isSortable: false, mods: "u-size1of2" },
        { name: "activePrograms", label: "Active Programs", isSortable: false, mods: "u-size1of2" },
    ];
    function loadData(_a) {
        var page = _a.page, itemsPerPage = _a.itemsPerPage, sortBy = _a.sortBy, sortAsc = _a.sortAsc, filter = _a.filter;
        return refetch({
            organizationId: orgId,
            pageNumber: page,
            pageSize: itemsPerPage,
            searchTerm: encodeURI(filter.searchTerm.trim()),
        }).then(function (val) {
            return val.data.members.data;
        });
    }
    function mapData(item, index) {
        var uniqueParticipantSeasons = lodash_1.uniqWith(item.seasonParticipants.map(function (m) { return m.season; }), lodash_1.isEqual);
        return {
            id: item.id,
            name: (React.createElement("div", null,
                React.createElement(react_router_dom_1.Link, { to: "/organizations/" + orgId + "/members/" + item.id }, displayLastNameFirst(item)))),
            activePrograms: item.seasonParticipants.length == 0 ? ("-") : (React.createElement("div", null, uniqueParticipantSeasons.map(function (e) { return (React.createElement("div", null,
                e.program.name,
                " ",
                React.createElement("span", { className: "u-colorGrey" },
                    "(",
                    e.name,
                    ")"))); }))),
            firstName: item.firstName,
            lastName: item.lastName,
            insertedAt: item.insertedAt,
            gender: item.gender,
            birthdate: item.birthdate,
        };
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", null, forceReload || !data ? null : (React.createElement(teamsnap_ui_1.PaginatedTable, { loadData: loadData, mapDataToRow: mapData, columns: columns, bulkActions: [
                {
                    label: "Merge members",
                    onSelected: function (selected) {
                        setMergeMembers(selected);
                    },
                },
            ], rowsAreSelectable: true, defaultItemsPerPage: defaultPageSize, totalItems: data.members.metadata.totalEntries, hideRowsSelect: true, includeBasicSearch: true, searchPlaceholder: "Seach by member name..." }))),
        React.createElement(merge_members_modal_1.default, { members: mergeMembers, isOpen: mergeMembers.length > 0, onMergeSuccess: function () { setMergeMembers([]); setForceReload(true); }, onClose: function () { return setMergeMembers([]); }, orgId: orgId })));
};
exports.default = MemberList;
//# sourceMappingURL=member-list.js.map